import { render, staticRenderFns } from "./PatientItem.vue?vue&type=template&id=882a17f0&scoped=true&"
import script from "./PatientItem.vue?vue&type=script&lang=ts&"
export * from "./PatientItem.vue?vue&type=script&lang=ts&"
import style0 from "./PatientItem.vue?vue&type=style&index=0&id=882a17f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882a17f0",
  null
  
)

export default component.exports